<template>
  <label :for="value.Value" class="brand">
    <input
      type="radio"
      class="u-hidden"
      name="Brands"
      :id="value.Value"
      :checked="value.IsSelected"
      @click="setSelectedItem">
    <span><slot></slot></span>
  </label>
</template>

<script>
    export default {
        props: ['value'],
        methods: {
            setSelectedItem () {
              this.$set(this.value, 'IsSelected', !this.value.IsSelected);
              this.$emit('item-selected', this.value.Value);
              this.$emit('product-change');
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/form/filters/FilterBrandsElement.vue